import { render, staticRenderFns } from "./FrakturaTicketSellerPdf.vue?vue&type=template&id=2e370dc4&scoped=true&class=page"
import script from "./FrakturaTicketSellerPdf.vue?vue&type=script&lang=js"
export * from "./FrakturaTicketSellerPdf.vue?vue&type=script&lang=js"
import style0 from "./FrakturaTicketSellerPdf.vue?vue&type=style&index=0&id=2e370dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e370dc4",
  null
  
)

export default component.exports